export default __webpack_public_path__ + "static/media/loader.65b11926.svg";